import { MessageSquare } from 'lucide-react';
import { InboxLayout } from '@/components/shared-inbox';
import type { InboxPlatformConfig, InboxStore } from '@/components/shared-inbox';
import { useInboxStore } from '@/stores/useInboxStore';
import { whatsappInboxHooks } from '@/api/whatsappInboxAdapters';

const PLATFORM_CONFIG: InboxPlatformConfig = {
    name: 'whatsapp',
    label: 'WhatsApp',
    icon: MessageSquare,
    searchPlaceholder: 'Search by name, phone, business...',
    windowExpiredText: '24h messaging window expired. Send a template message to reopen.',
    resumeAiBtnVariant: 'green',
};

export function WhatsappInbox() {
    const raw = useInboxStore();

    const store: InboxStore = {
        selectedConversationId: raw.selectedConversationId,
        showAgentConfig: raw.showAgentConfig,
        setSelectedConversationId: raw.setSelectedConversation,
        clearSelectedConversationId: raw.clearSelectedConversation,
        toggleAgentConfig: raw.toggleAgentConfig,
        setShowAgentConfig: raw.setShowAgentConfig,
    };

    return (
        <InboxLayout
            platform={PLATFORM_CONFIG}
            hooks={whatsappInboxHooks}
            store={store}
        />
    );
}
